import { Button, styled } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const MainContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
  gap: 5,
});

export const TwoColumn = styled('div')({
  display: 'flex',
  gap: 15,
});

export const CustomButton = styled(Button)({
  borderRadius: 5,
  background: '#0f1621',
  border: '1px solid',
  borderColor: COLORS.PRIMARY,
  height: 44,
  fontSize: 14,
  margin: '10px 0 20px',
});
